import { render, staticRenderFns } from "./reportLinkTemplate1.vue?vue&type=template&id=332458a8"
import script from "./reportLinkTemplate1.vue?vue&type=script&lang=js"
export * from "./reportLinkTemplate1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports